import styled from "styled-components";

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  padding: 2rem;
  box-sizing: border-box;
  height: 100vh;
  /* overflow: hidden; */
`;

export const ImageContainer = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  justify-content: center;
  width: 40%;
  justify-self: center;
  padding: 2rem 0;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: -0.5rem;
  margin-bottom: 1rem;
`;

export const ArtDescriptionContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  align-self: center;
`;

export const CreatePasswordContainer = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
  text-align: center;
`;

export const ArtImage = styled.img`
  object-fit: cover;
  border-radius: 1.5rem;
  width: 100%;
  height: calc(100% - 2rem);
`;
